/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectDto } from '../models/project-dto';

@Injectable({
  providedIn: 'root',
})
export class ProjectRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createOrUpdateProject
   */
  static readonly CreateOrUpdateProjectPath = '/api/v1/projects/{cvId}';

  /**
   * Adds or updates Project passed to the method to cv based on the given cv Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateProject$Response(params: {
    cvId: string;
    body: ProjectDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProjectDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRestControllerService.CreateOrUpdateProjectPath, 'post');
    if (params) {
      rb.path('cvId', params.cvId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectDto>;
      })
    );
  }

  /**
   * Adds or updates Project passed to the method to cv based on the given cv Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateProject(params: {
    cvId: string;
    body: ProjectDto
  },
  context?: HttpContext

): Observable<ProjectDto> {

    return this.createOrUpdateProject$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProjectDto>) => r.body as ProjectDto)
    );
  }

  /**
   * Path part for operation deleteProject
   */
  static readonly DeleteProjectPath = '/api/v1/projects/{cvId}';

  /**
   * Removes Project passed to the method from cv based on the given cv Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProject$Response(params: {
    cvId: number;
    body: ProjectDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRestControllerService.DeleteProjectPath, 'delete');
    if (params) {
      rb.path('cvId', params.cvId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Project passed to the method from cv based on the given cv Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProject(params: {
    cvId: number;
    body: ProjectDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteProject$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation batchCreateOrUpdateProjects
   */
  static readonly BatchCreateOrUpdateProjectsPath = '/api/v1/projects/{cvId}/batch';

  /**
   * Batch create or update projects for a CV.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `batchCreateOrUpdateProjects()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  batchCreateOrUpdateProjects$Response(params: {
    cvId: number;
    body: Array<ProjectDto>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ProjectDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRestControllerService.BatchCreateOrUpdateProjectsPath, 'post');
    if (params) {
      rb.path('cvId', params.cvId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectDto>>;
      })
    );
  }

  /**
   * Batch create or update projects for a CV.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `batchCreateOrUpdateProjects$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  batchCreateOrUpdateProjects(params: {
    cvId: number;
    body: Array<ProjectDto>
  },
  context?: HttpContext

): Observable<Array<ProjectDto>> {

    return this.batchCreateOrUpdateProjects$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ProjectDto>>) => r.body as Array<ProjectDto>)
    );
  }

  /**
   * Path part for operation getProjectById
   */
  static readonly GetProjectByIdPath = '/api/v1/projects/{id}';

  /**
   * Provides ProjectDto based on given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProjectDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRestControllerService.GetProjectByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectDto>;
      })
    );
  }

  /**
   * Provides ProjectDto based on given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<ProjectDto> {

    return this.getProjectById$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProjectDto>) => r.body as ProjectDto)
    );
  }

  /**
   * Path part for operation getProjects
   */
  static readonly GetProjectsPath = '/api/v1/projects/all';

  /**
   * Provides the list of all Project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjects$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ProjectDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRestControllerService.GetProjectsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectDto>>;
      })
    );
  }

  /**
   * Provides the list of all Project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjects(params?: {
  },
  context?: HttpContext

): Observable<Array<ProjectDto>> {

    return this.getProjects$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ProjectDto>>) => r.body as Array<ProjectDto>)
    );
  }

}
